"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toggleHydrogens = toggleHydrogens;
const getImplicitHydrogensCount_1 = require("./getImplicitHydrogensCount");
/**
 * Toggle presence of implicity hydrogens on/off
 * @param molecule
 * @param atomID
 */
function toggleHydrogens(molecule, atomID) {
    if ((0, getImplicitHydrogensCount_1.getImplicitHydrogensCount)(molecule, atomID) === 0) {
        const atomsToDelete = [];
        for (let i = 0; i < molecule.getAllConnAtoms(atomID); i++) {
            const connectedAtom = molecule.getConnAtom(atomID, i);
            if (molecule.getAtomicNo(connectedAtom) === 1) {
                atomsToDelete.push(connectedAtom);
            }
        }
        molecule.deleteAtoms(atomsToDelete);
    }
    else {
        molecule.addImplicitHydrogens(atomID);
    }
}
//# sourceMappingURL=toggleHydrogens.js.map